import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IStudentsStatusInitialState} from "../types";
import {IEntityWithIDTranslations} from "../../../../../../../types";
import {GetStudentsStatus} from "./thunk";

const initialState: IStudentsStatusInitialState = {
    studentsStatus: [],
    isLoadingStudentsStatus: true,
    filteredStudentsStatus: [],
    selectedStudentsStatusIDs: [],

}


const studentsStatusSlice = createSlice({
    name: "studentsStatus",
    initialState,
    reducers: {
        setStudentsStatus: (state, action: PayloadAction<{
            data: IEntityWithIDTranslations[],
            defaultLanguage: string
        }>) => {
            const {data, defaultLanguage} = action.payload;
            state.studentsStatus = data

            state.filteredStudentsStatus = state.studentsStatus.flatMap(
                (data) => {
                    return data.translations
                        .filter((elem) => elem.slug === defaultLanguage)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name || "Unknown Name",

                        }));
                }
            );
        },
        deletedStudentsStatus: (state, action: PayloadAction<number>) => {
            state.studentsStatus = state.studentsStatus.filter(
                (elem) => elem.id !== action.payload
            );

        },
        updateStudentsStatus: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;

            state.studentsStatus = state.studentsStatus.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },



        setSelectedStudentsStatusIDs: (state, action) => {
            state.selectedStudentsStatusIDs = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetStudentsStatus.pending, (state) => {
                state.isLoadingStudentsStatus = true;
            })
            .addCase(GetStudentsStatus.fulfilled, (state) => {
                state.isLoadingStudentsStatus = false;
            })
            .addCase(GetStudentsStatus.rejected, (state) => {
                state.isLoadingStudentsStatus = false;
            })

    },
})

export const {

    setSelectedStudentsStatusIDs,

    deletedStudentsStatus,
    updateStudentsStatus,
    setStudentsStatus
} = studentsStatusSlice.actions;

export default studentsStatusSlice